/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';

/**
* Agreement or refund with credit information
*/
export class AgreementWithCredits {
  /**
  * Unique identifier for the agreement or refund.
  */
  'id': string;
  /**
  * Marketplace account ID associated with this agreement.
  */
  'marketplaceAccountId': string;
  /**
  * Start time of the agreement or refund.
  */
  'startTime'?: Date;
  /**
  * Expiration time of the credit source. For agreements: the contract end date after which unused credits expire. For refunds: the expiration date after which unused refund credits expire. May be empty if the credit source has no expiration. 
  */
  'endTime'?: Date;
  /**
  * Original credit amount of the agreement.
  */
  'originalCredits': number;
  /**
  * Remaining credit amount that has not yet been consumed. Credits are consumed incrementally during billing cycles, so this value decreases over time as portions are used each billing period. A value of 0 means all credits have been fully consumed. 
  */
  'remainingCredits': number;
  'cloudProvider': Provider;
  /**
  * Type of credit source.
  */
  'type': AgreementWithCreditsTypeEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "marketplaceAccountId",
      "baseName": "marketplaceAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "originalCredits",
      "baseName": "originalCredits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "remainingCredits",
      "baseName": "remainingCredits",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "AgreementWithCreditsTypeEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AgreementWithCredits.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AgreementWithCreditsTypeEnum {
  Agreement = 'AGREEMENT',
  Refund = 'REFUND'
}

